/* ============
 * State of user module
 * ============
 *
 * The initial state of the suggestion module.
 */

export default {
  popupNpsFinal: false,
  taggeoNps: {
    tipoDocumento: null,
    numeroDocumento: null,
    categoria: 'NPS',
    nombre: null,
    datos: {
      numeroPoliza: null,
      productoConsultado: null,
      subproductoConsultado: null,
      seccion: null,
      funcionalidad: null,
      calificacion: null,
      razonCalificacion: null,
      otros: null
    },
    fecha: null
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/nps/state.js